import { myAxios } from "./axios";

export function getFeedbacks(payload = {}, { page, limit } = {}) {
    const { dealId, ...rest } = payload;

    if (!dealId) {
        throw new Error("dealId is required to fetch logs.");
    }

    const config = {
        params: {
            page,
            limit,
            ...rest,
        },
    };

    return myAxios.get(`/feedback/get/${dealId}`, config);
}


export function getFeedback(id) {
    return myAxios.get("/feedback/" + id);
}

export function addFeedback(data, dealId) {
    return myAxios.post(`/feedback/${dealId}`, data);
}

export function editFeedback(id, data) {
    return myAxios.put("/feedback/" + id, data);
}

export function deleteFeedback(id) {
    return myAxios.delete("/feedback/" + id);
}
